import { computed } from 'vue'

/**
 * Privacy policy / terms of service / FAQ destinations.
 *
 * These used to be built by appending pt-BR paths (`/privacidade`,
 * `/termos-de-uso`) to the commercial website URL, which is a whitelabel bug:
 * a deployment that is not masterdaweb.com got a 404 on its own domain, in a
 * language it may not even publish in. They are full URLs now, one env var
 * each, so a deployment can point them anywhere — a different domain, a docs
 * host, a PDF.
 *
 * Unset falls back to the commercial website root, which is never a 404 and is
 * always the right brand. With no commercial website either, the link resolves
 * to `null` and the caller renders plain text instead of a dead link.
 */
export function useLegalLinks() {
  const config = useRuntimeConfig()

  const commercial = computed(() => (config.public.commercialWebsiteUrl as string) || '')
  const resolve = (url: unknown) => computed(() => (url as string) || commercial.value || null)

  return {
    privacyUrl: resolve(config.public.privacyUrl),
    termsUrl: resolve(config.public.termsUrl),
    faqUrl: resolve(config.public.faqUrl)
  }
}
